'use client'

import { useTranslations } from 'next-intl'

export function FooterFootnote() {
  const t = useTranslations('components.studio_footer')

  return (
    <span suppressHydrationWarning={true}>{t('footnote', { year: new Date().getFullYear() })}</span>
  )
}
